import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { userLoggedOut } from '../../features/auth/authSlice';
import { selectUser } from '../../features/auth/selector';

const TopBar = () => {
    const { user } = useSelector(selectUser)
    const dispatch = useDispatch()
    const handleLogout = () => {
        dispatch(userLoggedOut())
        // clear 
        localStorage.setItem(
            "auth",
            JSON.stringify({

            })
        );
    }
    return (
        <nav className="shadow-md">
            <div className="max-w-7xl px-5 lg:px-0 mx-auto items-center flex justify-between py-3">
                <Link to={user.role === 'admin' ? "/admin/dashboard" : '/'}>
                    <img className="h-10" src="/image/learningportal.svg" />
                </Link>
                <div className='hidden md:block'>
                    <Link to='/leaderboard' className='font-bold hover:opacity-70'>Leaderboard</Link>

                    <Link to='/course' className='font-bold hover:opacity-70 ml-4'>Courses</Link>

                    {/* user.role === 'student' && <Link to='/leaderboard' className='font-bold ml-4 hover:opacity-70'>Your activity</Link> */}

                    {
                        user.role === 'admin' && <Link to='/admin/dashboard' className='font-bold ml-4 hover:opacity-70'>Dashboard</Link>
                    }

                </div>
                <div className="flex items-center gap-3">
                    <h2 className="font-bold">{user.name}</h2>
                    <button
                        onClick={handleLogout}
                        className="flex gap-2 items-center px-4 py-1 rounded-full text-sm transition-all bg-red-600 hover:bg-red-700 font-medium">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                            stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round"
                                d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
                        </svg>
                        Logout
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default TopBar;